module.exports = __webpack_public_path__ + "static/media/escolhaUnicaOutro.542d1a88.jpg";